import React from 'react';

const HireDesignerUpload = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 10.5L20 5.5M20 5.5L25 10.5M20 5.5L20 25.5"
      stroke="black"
      strokeOpacity="0.6"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 15.5L11.6667 15.5C7.98477 15.5 5 18.4848 5 22.1667L5 28.8333C5 32.5152 7.98477 35.5 11.6667 35.5L28.3333 35.5C32.0152 35.5 35 32.5152 35 28.8333L35 22.1667C35 18.4848 32.0152 15.5 28.3333 15.5L27.5 15.5"
      stroke="black"
      strokeOpacity="0.6"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HireDesignerUpload;
